import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  setClearErrorAction,
  setDeletePartner,
  setOnePartner,
  setStatusText,
} from "../../store/partner/slice";
import { setImageSlice } from "../../store/image/slice";
import { setModalOpen } from "../../store/modal/slice";
import { PartnerAPI } from "../../services/partner";
import Search from "../../components/search/search";
import Pagination from "../../components/pagination/pagination";
import Item from "./components/item/Item";
import PageTitle from "../../components/page-title/page-title";
import useActionHandlers from "../../hooks/useActionHandlers";
import { handleResponseStatus } from "../../utils/handle-response-status";
import CreateBtn from "../../components/create-btn/create-btn";
import Params from "../../helpers/params";

import styles from "./styles.module.scss";

const PartnerAuthorized = () => {
  const dispatch = useDispatch();

  const { status, authorizes, authorizes_total, errorStatus } = useSelector(
    (state) => state.partner
  );
  const { offset } = useSelector((state) => state.pagination);

  const { control, handleSubmit, getValues } = useForm({
    defaultValues: {
      search: "",
      company_is: "authorized",
    },
  });

  const ACTION_HANDLERS = useActionHandlers("", PartnerAPI, {
    setDeletedEntityId: setDeletePartner,
    setModalOpen,
    deleteEntity: "deletePartner",
  });

  const handleSearch = handleSubmit(async (data) => {
    try {
      await dispatch(
        PartnerAPI.getPartnersAuthorized({ ...data, ...Params() })
      ).unwrap();
    } catch (error) {
      console.error(error.message);
    }
  });

  useEffect(() => {
    handleResponseStatus({
      status,
      errorStatus,
      dispatchActions: [
        { action: dispatch, payload: setStatusText(null) },
        { action: dispatch, payload: setImageSlice(null) },
      ],
      successMessage: "Հաջողությամբ հեռացված է ցանկից",
      errorMessage: errorStatus,
      clearErrorAction: () => dispatch(setClearErrorAction()),
    });
  }, [status, errorStatus, dispatch]);

  useEffect(() => {
    (async () => {
      try {
        const searchValue = getValues("search");
        const params = {
          company_is: "authorized",
          ...Params(20, offset * 20),
        };

        if (searchValue) params.search = searchValue;

        await dispatch(PartnerAPI.getPartnersAuthorized(params)).unwrap();
      } catch (error) {
        console.error(error.message);
      }
    })();
  }, [dispatch, status, offset, getValues]);

  useEffect(() => {
    dispatch(setOnePartner(null));
    dispatch(setImageSlice(null));
  }, [dispatch]);

  return (
    <div>
      <PageTitle title="Գործընկերներ" />
      <div className={styles.top_bar}>
        <CreateBtn
          className={styles.btn_create}
          onClick={ACTION_HANDLERS.create}
          text="Ավելացնել նոր կազմակերպություն"
        />
        <Search
          control={control}
          name="search"
          onSearch={handleSearch}
          className={styles.search}
        />
      </div>
      <div>
        {authorizes?.length ? (
          authorizes.map((item) => (
            <Item item={item} key={item.id} actions={ACTION_HANDLERS} />
          ))
        ) : (
          <h4>Այս պահին ցանկը դատարկ է</h4>
        )}
      </div>
      <Pagination offset={offset} total={authorizes_total} />
    </div>
  );
};

export default PartnerAuthorized;
